import { ChatMessageType } from './chat-message.i';
import { TimelineItemType } from '../timeline/timeline';
import { UserBuilder } from '../../common';
var ChatMessageBuilder = /** @class */ (function () {
    function ChatMessageBuilder() {
        this.chatMessage = {
            byAgent: false,
            id: '000-111-000',
            ticketId: '000-111-000',
            chatId: '000-111-000',
            userId: '000-111-000',
            externalId: '000-111-000',
            content: 'hola que pasa',
            text: 'hola que pasa',
            chatMessageData: { attachments: [] },
            chatMessageType: ChatMessageType.USER,
            messageCreationDate: 0,
            creationDate: 0,
            timelineItemType: TimelineItemType.CHAT_MESSAGE,
            user: new UserBuilder().build(),
            lastUpdateDate: 0,
            deleted: false
        };
    }
    ChatMessageBuilder.prototype.withByAgent = function (byAgent) {
        this.chatMessage.byAgent = byAgent;
        return this;
    };
    ChatMessageBuilder.prototype.withContent = function (content) {
        this.chatMessage.content = content;
        this.chatMessage.text = content;
        return this;
    };
    ChatMessageBuilder.prototype.withText = function (text) {
        this.chatMessage.text = text;
        this.chatMessage.content = text;
        return this;
    };
    ChatMessageBuilder.prototype.withChatMessageType = function (chatMessageType) {
        this.chatMessage.chatMessageType = chatMessageType;
        return this;
    };
    ChatMessageBuilder.prototype.withChatMessageData = function (chatMessageData) {
        this.chatMessage.chatMessageData = chatMessageData;
        return this;
    };
    ChatMessageBuilder.prototype.withTicketId = function (ticketId) {
        this.chatMessage.ticketId = ticketId;
        return this;
    };
    ChatMessageBuilder.prototype.withId = function (id) {
        this.chatMessage.id = id;
        return this;
    };
    ChatMessageBuilder.prototype.withExternalId = function (externalId) {
        this.chatMessage.externalId = externalId;
        return this;
    };
    ChatMessageBuilder.prototype.withUserId = function (userId) {
        this.chatMessage.userId = userId;
        return this;
    };
    ChatMessageBuilder.prototype.withUser = function (user) {
        this.chatMessage.user = user;
        return this;
    };
    ChatMessageBuilder.prototype.withMessageCreationDate = function (messageCreationDate) {
        this.chatMessage.messageCreationDate = messageCreationDate;
        return this;
    };
    ChatMessageBuilder.prototype.withCreationDate = function (creationDate) {
        this.chatMessage.creationDate = creationDate;
        return this;
    };
    ChatMessageBuilder.prototype.withLastUpdateDate = function (lastUpdateDate) {
        this.chatMessage.lastUpdateDate = lastUpdateDate;
        return this;
    };
    ChatMessageBuilder.prototype.withDeleted = function (deleted) {
        this.chatMessage.deleted = deleted;
        return this;
    };
    ChatMessageBuilder.prototype.build = function () {
        return this.chatMessage;
    };
    return ChatMessageBuilder;
}());
export { ChatMessageBuilder };
//# sourceMappingURL=chat-message.builder.js.map